import {
  ColumnActionsMode,
  IColumn,
  IconButton,
  IContextualMenuItem,
  IContextualMenuProps
} from "@fluentui/react";

import { ContractItem } from "../contract.interface";

export interface ActionColumnConfig {
  menuItems: (item: ContractItem) => IContextualMenuItem[];
  shouldRender?: (item: ContractItem) => boolean;
}

export function createActionsColumn(
  actionConfig?: ActionColumnConfig
): IColumn {
  return {
    key: "actions",
    name: "Ações",
    fieldName: "actions",
    minWidth: 40,
    maxWidth: 40,
    columnActionsMode: ColumnActionsMode.disabled,
    isIconOnly: true,
    onRender: (item: ContractItem) => {
      if (!actionConfig?.menuItems) {
        return null;
      }

      if (actionConfig.shouldRender && !actionConfig.shouldRender(item)) {
        return null;
      }

      const menuProps: IContextualMenuProps = {
        items: actionConfig.menuItems(item)
      };

      return (
        <IconButton
          id={`actions-${item.id}`}
          menuProps={menuProps}
          iconProps={{ iconName: "MoreVertical" }}
          onRenderMenuIcon={() => null}
        />
      );
    }
  };
}
